module.exports = __webpack_public_path__ + "static/laptop-b9e8a0b24aca8f862637a88e87c7dd09.png";